import { PluginListenerHandle, registerPlugin } from '@capacitor/core';

export interface TwilioVoiceRegisterOptions {
    accessToken: string;
    identity?: string;
    expiresIn?: number;
}

export interface NativeTwilioVoiceEvent {
    callSid?: string;
    displayedCallSid?: string;
    callStatus?: string;
    conversationId?: string | number | null;
    from?: string;
    callerName?: string;
    dealerId?: string | number | null;
    toNumber?: string | null;
    error?: string | null;
    message?: string;
}

export interface TwilioVoicePlugin {
    ensurePermissions(): Promise<{ microphoneGranted: boolean }>;
    ensureSystemCallUi(): Promise<{ setupOpened: boolean }>;
    setMuted(options: { muted: boolean }): Promise<{ muted: boolean }>;
    setSpeakerEnabled(options: { enabled: boolean }): Promise<{ enabled: boolean }>;
    configureSession(options: {
        apiUrl: string;
        appToken: string;
        authToken: string;
        userToken: string;
    }): Promise<{ configured: boolean }>;
    register(options: TwilioVoiceRegisterOptions): Promise<{ registered: boolean }>;
    unregister(): Promise<{ unregistered: boolean }>;
    startOutgoingCall(options: {
        to: string;
        from: string;
        conversationId?: string | number | null;
        customerId?: string | number | null;
        dealerId?: string | number | null;
        agentId?: string | number | null;
        contactName?: string | null;
    }): Promise<{ started: boolean }>;
    answerIncomingCall(): Promise<{ answered: boolean }>;
    rejectIncomingCall(): Promise<{ rejected: boolean }>;
    disconnectActiveCall(): Promise<{ disconnected: boolean }>;
    getCallState(): Promise<{
        callSid?: string | null;
        displayedCallSid?: string | null;
        callStatus?: string | null;
        hasActiveCall?: boolean;
        isOnHold?: boolean;
        isMuted?: boolean;
        speakerEnabled?: boolean;
    }>;
    openCallScreen(options: {
        callerName?: string | null;
        callerNumber?: string | null;
        conversationId?: string | number | null;
        callSid?: string | null;
        dealerId?: string | number | null;
        toNumber?: string | null;
        callStatus?: string | null;
        inCallMode?: boolean;
    }): Promise<{ opened: boolean }>;
    addListener(
        eventName:
            | 'callInvite'
            | 'callConnecting'
            | 'callRinging'
            | 'callConnected'
            | 'callReconnecting'
            | 'callReconnected'
            | 'callDisconnected'
            | 'callCancelled'
            | 'callConnectFailure'
            | 'callStateChanged'
            | 'registrationError',
        listenerFunc: (event: NativeTwilioVoiceEvent) => void
    ): Promise<PluginListenerHandle>;
}

export const TwilioVoice = registerPlugin<TwilioVoicePlugin>('TwilioVoice');
